import store from '@/store';
import http from './http';

export default {
  getList({
    wheel,
    wheelIdentifier,
    locale,
    player,
    params,
  }) {
    const page = params.page || 1;
    const size = params.size || 10;
    let path = `tickets/${wheel}/players/${player}`;

    if (store.getters.platform.platformName === 'NextGen') {
      path = `${path}?platform=nextGen`;
    }

    return http.get(path, {
      params: {
        wheelAccountId: wheelIdentifier,
        includeBets: params.includeBets,
        dateFrom: params.dateFrom,
        dateTo: params.dateTo,
        page,
        locale,
        size,
      },
    }).then((response) => response.data);
  },
};
